/**
 * Lowercase ASCII form of Vietnamese text for accent-insensitive matching
 * (e.g. "Ha Noi" matches "Hà Nội").
 */
export function removeVietnameseTones(str: string): string {
  if (!str) return "";
  return str
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/đ/g, "d")
    .replace(/Đ/g, "D");
}

export function vietnameseToneInsensitiveIncludes(
  haystack: string,
  needle: string,
): boolean {
  const a = removeVietnameseTones(haystack).toLowerCase();
  const b = removeVietnameseTones(needle).toLowerCase();
  return a.includes(b);
}
